<template>
  <div id="yuanDesc" style="height: auto">
    <!--    <nav id="main-navigation" class="collapse navbar-collapse">
      <ul class="nav navbar-nav navbar-right fog-navbar-nav">
        <li><a href="#app-description">Why Us</a></li>
        <li><a href="#service">概况</a></li>
        <li><a href="#org">需求学科</a></li>
        <li><a href="#pricing-table">待遇及招聘流程</a></li>
        <li><a href="#contact">联系我们</a></li>
        <li><a href="#testimonials">敬请关注</a></li>
      </ul>
    </nav>-->
    <!-- =========================
       SERVICE HOME - 1
  ============================== -->
    <!--    <section id="home" class="home video-bg service-home-1">-->
    <!--      <div class="overlay">-->
    <!--        <div class="container">-->
    <!--          <div class="home-content text-center">-->
    <!--            <div class="t2" style="margin-top: 80px">&nbsp;</div>-->
    <!--            <div class="t1">铸国防基石 做民族脊梁</div>-->
    <!--            &lt;!&ndash;            <div class="t2" style="margin-top: 80px">-->
    <!--              ——中国工程物理研究院-->
    <!--              <span id="currentYear" />-->
    <!--              年度校园招聘宣讲开始啦-->
    <!--            </div>&ndash;&gt;-->
    <!--            <div class="t2" style="margin-top: 80px">-->
    <!--              <span id="title1"></span>-->
    <!--            </div>-->
    <!--            <div class="t2" style="margin-top: 30px">-->
    <!--              <span id="title2"></span>-->
    <!--            </div>-->
    <!--            <div class="t2" style="margin-top: 30px">-->
    <!--              <span id="title3"></span>-->
    <!--            </div>-->
    <!--            <div class="t2" style="margin-top: 80px">&nbsp;</div>-->
    <!--            <div id="info1" class="t3" style="margin-top: 80px">-->
    <!--              <span>-->
    <!--                <a href="https://zpxx.caep.cn/#/yuanDesc/index">-->
    <!--                  <img src="./images/clickin511.png" />-->
    <!--                </a>-->
    <!--              </span>-->
    <!--            </div>-->

    <!--            &lt;!&ndash;                <div class="mt-60">&ndash;&gt;-->
    <!--            &lt;!&ndash;                    <form id="subscribe" class="form-inline">&ndash;&gt;-->
    <!--            &lt;!&ndash;                        <div class="form-group">&ndash;&gt;-->

    <!--            &lt;!&ndash;                            <label class="sr-only">Your Email</label>&ndash;&gt;-->
    <!--            &lt;!&ndash;                            <input type="email" class="form-control" placeholder="Your Email">&ndash;&gt;-->

    <!--            &lt;!&ndash;                        </div>&ndash;&gt;-->
    <!--            &lt;!&ndash;                        <button type="submit" class="btn btn-cmd btn-base">Subscribe Now!</button>&ndash;&gt;-->
    <!--            &lt;!&ndash;                    </form>&ndash;&gt;-->
    <!--            &lt;!&ndash;                </div>&ndash;&gt;-->

    <!--            &lt;!&ndash;                <p class="success-msg"></p>&ndash;&gt;-->
    <!--            &lt;!&ndash;                <p class="error-msg"></p>&ndash;&gt;-->
    <!--          </div>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--      &lt;!&ndash; end of /.overlay &ndash;&gt;-->
    <!--    </section>-->
    <!--    <section v-if="!isPhone()" id="app-description1" class="app-description-2">-->
    <section v-if="false" id="app-description1" class="app-description-2">
      <div class="container">
        <!-- SECTION HEADING -->
        <div class="row">
          <div class="col-md-8 col-md-offset-2 col-sm-10 col-sm-offset-1">
            <header class="section-heading text-center">
              <h3 class="title-text">2025届秋季招聘行程安排</h3>
            </header>
          </div>
        </div>
        <!-- /END SECTION HEADING -->
        <!--        <div class="row">-->
        <div>
          <div class="service-item text-center">
            <div class="zp-table">
              <div class="zp-table-title">
                <div class="zp-table-column">
                  <div class="zp-table-info">星期一</div>
                </div>
                <div class="zp-table-column">
                  <div class="zp-table-info">星期二</div>
                </div>
                <div class="zp-table-column">
                  <div class="zp-table-info">星期三</div>
                </div>
                <div class="zp-table-column">
                  <div class="zp-table-info">星期四</div>
                </div>
                <div class="zp-table-column">
                  <div class="zp-table-info">星期五</div>
                </div>
                <div class="zp-table-column">
                  <div class="zp-table-info">星期六</div>
                </div>
                <div class="zp-table-column">
                  <div class="zp-table-info">星期日</div>
                </div>
              </div>
              <div class="zp-table-cell">
                <div class="zp-table-column1">
                  <div class="zp-table-info">8月26日</div>
                </div>
                <div class="zp-table-column1">
                  <div class="zp-table-info">8月27日</div>
                </div>
                <div class="zp-table-column1">
                  <div class="zp-table-info">8月28日</div>
                </div>
                <div class="zp-table-column1">
                  <div class="zp-table-info">8月29日</div>
                </div>
                <div class="zp-table-column1">
                  <div class="zp-table-info">8月30日</div>
                </div>
                <div class="zp-table-column1">
                  <div class="zp-table-info">8月31日</div>
                </div>
                <div class="zp-table-column1">
                  <div class="zp-table-info">9月1日</div>
                </div>
              </div>
              <div class="zp-table-content">
                <div class="zp-table-firstBox"></div>
                <div class="zp-table-firstBox"></div>
                <div class="zp-table-firstBox"></div>
                <div class="zp-table-firstBox"></div>
                <div class="zp-table-firstBox">
                  <div class="zp-table-info">西北工业大学</div>
                </div>
                <div class="zp-table-firstBox"></div>
                <div class="zp-table-firstBox"></div>
              </div>
              <div class="zp-table-cell">
                <div class="zp-table-column1">
                  <div class="zp-table-info">9月2日</div>
                </div>
                <div class="zp-table-column1">
                  <div class="zp-table-info">9月3日</div>
                </div>
                <div class="zp-table-column1">
                  <div class="zp-table-info">9月4日</div>
                </div>
                <div class="zp-table-column1">
                  <div class="zp-table-info">9月5日</div>
                </div>
                <div class="zp-table-column1">
                  <div class="zp-table-info">9月6日</div>
                </div>
                <div class="zp-table-column1">
                  <div class="zp-table-info">9月7日</div>
                </div>
                <div class="zp-table-column1">
                  <div class="zp-table-info">9月8日</div>
                </div>
              </div>
              <div class="zp-table-content">
                <div class="zp-table-doubleBox">
                  <div class="zp-table-doublebox-info">哈尔滨工业大学</div>
                </div>
                <div class="zp-table-doubleBox">
                  <div class="zp-table-doublebox-info">哈尔滨工程大学</div>
                </div>
                <div class="zp-table-doubleBox">
                  <div class="zp-table-info">东北大学</div>
                  <div class="zp-table-info">大连理工大学</div>
                </div>
                <div class="zp-table-doubleBox">
                  <div class="zp-table-doublebox-info">吉林大学</div>
                </div>
                <div class="zp-table-doubleBox">
                  <div class="zp-table-doublebox-info">天津大学</div>
                </div>
                <div class="zp-table-doubleBox"></div>
                <div class="zp-table-doubleBox"></div>
              </div>
              <div class="zp-table-cell">
                <div class="zp-table-column1">
                  <div class="zp-table-info">9月9日</div>
                </div>
                <div class="zp-table-column1">
                  <div class="zp-table-info">9月10日</div>
                </div>
                <div class="zp-table-column1">
                  <div class="zp-table-info">9月11日</div>
                </div>
                <div class="zp-table-column1">
                  <div class="zp-table-info">9月12日</div>
                </div>
                <div class="zp-table-column1">
                  <div class="zp-table-info">9月13日</div>
                </div>
                <div class="zp-table-column1">
                  <div class="zp-table-info">9月14日</div>
                </div>
                <div class="zp-table-column1">
                  <div class="zp-table-info">9月15日</div>
                </div>
              </div>
              <div class="zp-table-content">
                <div class="zp-table-doubleBox">
                  <div class="zp-table-doublebox-info">山东大学</div>
                </div>
                <div class="zp-table-doubleBox">
                  <div class="zp-table-doublebox-info">浙江大学</div>
                </div>
                <div class="zp-table-doubleBox">
                  <div class="zp-table-doublebox-info">中国科学技术大学</div>
                </div>
                <div class="zp-table-doubleBox">
                  <div class="zp-table-doublebox-info">华中科技大学</div>
                </div>
                <div class="zp-table-doubleBox">
                  <div class="zp-table-info">四川大学</div>
                  <div class="zp-table-info">电子科技大学</div>
                </div>
                <div class="zp-table-doubleBox">
                  <div class="zp-table-doublebox-info">招聘主管培训</div>
                </div>
                <div class="zp-table-doubleBox"></div>
              </div>
              <div class="zp-table-cell">
                <div class="zp-table-column1">
                  <div class="zp-table-info">9月16日</div>
                </div>
                <div class="zp-table-column1">
                  <div class="zp-table-info">9月17日</div>
                </div>
                <div class="zp-table-column1">
                  <div class="zp-table-info">9月18日</div>
                </div>
                <div class="zp-table-column1">
                  <div class="zp-table-info">9月19日</div>
                </div>
                <div class="zp-table-column1">
                  <div class="zp-table-info">9月20日</div>
                </div>
                <div class="zp-table-column1">
                  <div class="zp-table-info">9月21日</div>
                </div>
                <div class="zp-table-column1">
                  <div class="zp-table-info">9月22日</div>
                </div>
              </div>
              <div class="zp-table-content">
                <div class="zp-table-doubleBox"></div>
                <div class="zp-table-doubleBox"></div>
                <div class="zp-table-doubleBox">
                  <div class="zp-table-info">西安电子科技大学</div>
                  <div class="zp-table-info">西安交通大学</div>
                </div>
                <div class="zp-table-doubleBox">
                  <div class="zp-table-doublebox-info">兰州大学</div>
                </div>
                <div class="zp-table-doubleBox"></div>
                <div class="zp-table-doubleBox"></div>
                <div class="zp-table-doubleBox"></div>
              </div>
              <div class="zp-table-cell">
                <div class="zp-table-column1">
                  <div class="zp-table-info">9月23日</div>
                </div>
                <div class="zp-table-column1">
                  <div class="zp-table-info">9月24日</div>
                </div>
                <div class="zp-table-column1">
                  <div class="zp-table-info">9月25日</div>
                </div>
                <div class="zp-table-column1">
                  <div class="zp-table-info">9月26日</div>
                </div>
                <div class="zp-table-column1">
                  <div class="zp-table-info">9月27日</div>
                </div>
                <div class="zp-table-column1">
                  <div class="zp-table-info">9月28日</div>
                </div>
                <div class="zp-table-column1">
                  <div class="zp-table-info">9月29日</div>
                </div>
              </div>
              <div class="zp-table-content">
                <div class="zp-table-doubleBox">
                  <div class="zp-table-doublebox-info">上海交通大学</div>
                </div>
                <div class="zp-table-doubleBox">
                  <div class="zp-table-doublebox-info">复旦大学</div>
                </div>
                <div class="zp-table-doubleBox">
                  <div class="zp-table-info">清华大学</div>
                  <div class="zp-table-info">北京理工大学</div>
                </div>
                <div class="zp-table-doubleBox">
                  <div class="zp-table-info">北京航空航天大学</div>
                  <div class="zp-table-info">北京大学</div>
                </div>
                <div class="zp-table-doubleBox"></div>
                <div class="zp-table-doubleBox"></div>
                <div class="zp-table-doubleBox">
                  <div class="zp-table-doublebox-info">重庆大学</div>
                </div>
              </div>
              <div class="zp-table-cell">
                <div class="zp-table-column1">
                  <div class="zp-table-info">9月30日</div>
                </div>
                <div class="zp-table-column1">
                  <div class="zp-table-info">10月1日</div>
                </div>
                <div class="zp-table-column1">
                  <div class="zp-table-info">10月2日</div>
                </div>
                <div class="zp-table-column1">
                  <div class="zp-table-info">10月3日</div>
                </div>
                <div class="zp-table-column1">
                  <div class="zp-table-info">10月4日</div>
                </div>
                <div class="zp-table-column1">
                  <div class="zp-table-info">10月5日</div>
                </div>
                <div class="zp-table-column1">
                  <div class="zp-table-info">10月6日</div>
                </div>
              </div>
              <div class="zp-table-content">
                <div class="zp-table-doubleBox"></div>
                <div class="zp-table-doubleBox"></div>
                <div class="zp-table-doubleBox"></div>
                <div class="zp-table-doubleBox"></div>
                <div class="zp-table-doubleBox"></div>
                <div class="zp-table-doubleBox"></div>
                <div class="zp-table-doubleBox"></div>
              </div>
              <div class="zp-table-cell">
                <div class="zp-table-column1">
                  <div class="zp-table-info">10月7日</div>
                </div>
                <div class="zp-table-column1">
                  <div class="zp-table-info">10月8日</div>
                </div>
                <div class="zp-table-column1">
                  <div class="zp-table-info">10月9日</div>
                </div>
                <div class="zp-table-column1">
                  <div class="zp-table-info">10月10日</div>
                </div>
                <div class="zp-table-column1">
                  <div class="zp-table-info">10月11日</div>
                </div>
                <div class="zp-table-column1">
                  <div class="zp-table-info">10月12日</div>
                </div>
                <div class="zp-table-column1">
                  <div class="zp-table-info">10月13日</div>
                </div>
              </div>
              <div class="zp-table-content">
                <div class="zp-table-doubleBox"></div>
                <div class="zp-table-doubleBox">
                  <div class="zp-table-doublebox-info">中南大学</div>
                </div>
                <div class="zp-table-doubleBox">
                  <div class="zp-table-doublebox-info">国防科技大学</div>
                </div>
                <div class="zp-table-doubleBox">
                  <div class="zp-table-info">南京航空航天大学</div>
                  <div class="zp-table-info">东南大学</div>
                </div>
                <div class="zp-table-doubleBox">
                  <div class="zp-table-info">南京理工大学</div>
                  <div class="zp-table-info">南京大学</div>
                </div>
                <div class="zp-table-doubleBox"></div>
                <div class="zp-table-doubleBox"></div>
              </div>
            </div>
          </div>
          <!--          </div>-->
        </div>
      </div>
    </section>
    <!-- =========================
       TESTIMONIALS - 1
  ============================== -->
    <!--    <section v-if="isPhone()" id="app-description2" class="app-description-2">-->
    <section v-if="false" id="app-description2" class="app-description-2">
      <div class="container">
        <!-- SECTION HEADING -->
        <div class="row">
          <div class="col-md-8 col-md-offset-2 col-sm-10 col-sm-offset-1">
            <header class="section-heading text-center">
              <h3 class="title-text">2025届秋季招聘行程安排</h3>
            </header>
          </div>
        </div>
        <!-- /END SECTION HEADING -->
        <!--        <div class="row">-->
        <div>
          <div class="service-item text-center">
            <div class="zp-table">
              <div class="zp-table-title">
                <div class="zp-table-column">
                  <div class="zp-table-info">周一</div>
                </div>
                <div class="zp-table-column">
                  <div class="zp-table-info">周二</div>
                </div>
                <div class="zp-table-column">
                  <div class="zp-table-info">周三</div>
                </div>
                <div class="zp-table-column">
                  <div class="zp-table-info">周四</div>
                </div>
                <div class="zp-table-column">
                  <div class="zp-table-info">周五</div>
                </div>
                <div class="zp-table-column">
                  <div class="zp-table-info">周六</div>
                </div>
                <div class="zp-table-column">
                  <div class="zp-table-info">周日</div>
                </div>
              </div>
              <div class="zp-table-cell">
                <div class="zp-table-column1">
                  <div class="zp-table-info">8/26</div>
                </div>
                <div class="zp-table-column1">
                  <div class="zp-table-info">8/27</div>
                </div>
                <div class="zp-table-column1">
                  <div class="zp-table-info">8/28</div>
                </div>
                <div class="zp-table-column1">
                  <div class="zp-table-info">8/29</div>
                </div>
                <div class="zp-table-column1">
                  <div class="zp-table-info">8/30</div>
                </div>
                <div class="zp-table-column1">
                  <div class="zp-table-info">8/31</div>
                </div>
                <div class="zp-table-column1">
                  <div class="zp-table-info">9/1</div>
                </div>
              </div>
              <div class="zp-table-content">
                <div class="zp-table-box"></div>
                <div class="zp-table-box"></div>
                <div class="zp-table-box"></div>
                <div class="zp-table-box"></div>
                <div class="zp-table-box">
                  <z-pcontent
                    ref="zpContent"
                    date="0830"
                    times="1"
                  ></z-pcontent>
                </div>
                <div class="zp-table-box"></div>
                <div class="zp-table-box"></div>
              </div>
              <div class="zp-table-cell">
                <div class="zp-table-column1">
                  <div class="zp-table-info">9/2</div>
                </div>
                <div class="zp-table-column1">
                  <div class="zp-table-info">9/3</div>
                </div>
                <div class="zp-table-column1">
                  <div class="zp-table-info">9/4</div>
                </div>
                <div class="zp-table-column1">
                  <div class="zp-table-info">9/5</div>
                </div>
                <div class="zp-table-column1">
                  <div class="zp-table-info">9/6</div>
                </div>
                <div class="zp-table-column1">
                  <div class="zp-table-info">9/7</div>
                </div>
                <div class="zp-table-column1">
                  <div class="zp-table-info">9/8</div>
                </div>
              </div>
              <div class="zp-table-content">
                <div class="zp-table-box">
                  <z-pcontent
                    ref="zpContent"
                    date="0902"
                    times="1"
                  ></z-pcontent>
                </div>
                <div class="zp-table-box">
                  <z-pcontent
                    ref="zpContent"
                    date="0903"
                    times="1"
                  ></z-pcontent>
                </div>
                <div class="zp-table-box">
                  <z-pcontent
                    ref="zpContent"
                    date="0904"
                    times="2"
                  ></z-pcontent>
                </div>
                <div class="zp-table-box">
                  <z-pcontent
                    ref="zpContent"
                    date="0905"
                    times="1"
                  ></z-pcontent>
                </div>
                <div class="zp-table-box">
                  <z-pcontent
                    ref="zpContent"
                    date="0906"
                    times="1"
                  ></z-pcontent>
                </div>
                <div class="zp-table-box"></div>
                <div class="zp-table-box"></div>
              </div>
              <div class="zp-table-cell">
                <div class="zp-table-column1">
                  <div class="zp-table-info">9/9</div>
                </div>
                <div class="zp-table-column1">
                  <div class="zp-table-info">9/10</div>
                </div>
                <div class="zp-table-column1">
                  <div class="zp-table-info">9/11</div>
                </div>
                <div class="zp-table-column1">
                  <div class="zp-table-info">9/12</div>
                </div>
                <div class="zp-table-column1">
                  <div class="zp-table-info">9/13</div>
                </div>
                <div class="zp-table-column1">
                  <div class="zp-table-info">9/14</div>
                </div>
                <div class="zp-table-column1">
                  <div class="zp-table-info">9/15</div>
                </div>
              </div>
              <div class="zp-table-content">
                <div class="zp-table-box">
                  <z-pcontent
                    ref="zpContent"
                    date="0909"
                    times="1"
                  ></z-pcontent>
                </div>
                <div class="zp-table-box">
                  <z-pcontent
                    ref="zpContent"
                    date="0910"
                    times="1"
                  ></z-pcontent>
                </div>
                <div class="zp-table-box">
                  <z-pcontent
                    ref="zpContent"
                    date="0911"
                    times="1"
                  ></z-pcontent>
                </div>
                <div class="zp-table-box">
                  <z-pcontent
                    ref="zpContent"
                    date="0912"
                    times="1"
                  ></z-pcontent>
                </div>
                <div class="zp-table-box">
                  <z-pcontent
                    ref="zpContent"
                    date="0913"
                    times="2"
                  ></z-pcontent>
                </div>
                <div class="zp-table-box"></div>
                <div class="zp-table-box"></div>
              </div>
              <div class="zp-table-cell">
                <div class="zp-table-column1">
                  <div class="zp-table-info">9/16</div>
                </div>
                <div class="zp-table-column1">
                  <div class="zp-table-info">9/17</div>
                </div>
                <div class="zp-table-column1">
                  <div class="zp-table-info">9/18</div>
                </div>
                <div class="zp-table-column1">
                  <div class="zp-table-info">9/19</div>
                </div>
                <div class="zp-table-column1">
                  <div class="zp-table-info">9/20</div>
                </div>
                <div class="zp-table-column1">
                  <div class="zp-table-info">9/21</div>
                </div>
                <div class="zp-table-column1">
                  <div class="zp-table-info">9/22</div>
                </div>
              </div>
              <div class="zp-table-content">
                <div class="zp-table-box"></div>
                <div class="zp-table-box"></div>
                <div class="zp-table-box">
                  <z-pcontent
                    ref="zpContent"
                    date="0918"
                    times="2"
                  ></z-pcontent>
                </div>
                <div class="zp-table-box">
                  <z-pcontent
                    ref="zpContent"
                    date="0919"
                    times="1"
                  ></z-pcontent>
                </div>
                <div class="zp-table-box"></div>
                <div class="zp-table-box"></div>
                <div class="zp-table-box"></div>
              </div>
              <div class="zp-table-cell">
                <div class="zp-table-column1">
                  <div class="zp-table-info">9/23</div>
                </div>
                <div class="zp-table-column1">
                  <div class="zp-table-info">9/24</div>
                </div>
                <div class="zp-table-column1">
                  <div class="zp-table-info">9/25</div>
                </div>
                <div class="zp-table-column1">
                  <div class="zp-table-info">9/26</div>
                </div>
                <div class="zp-table-column1">
                  <div class="zp-table-info">9/27</div>
                </div>
                <div class="zp-table-column1">
                  <div class="zp-table-info">9/28</div>
                </div>
                <div class="zp-table-column1">
                  <div class="zp-table-info">9/29</div>
                </div>
              </div>
              <div class="zp-table-content">
                <div class="zp-table-box">
                  <z-pcontent
                    ref="zpContent"
                    date="0923"
                    times="1"
                  ></z-pcontent>
                </div>
                <div class="zp-table-box">
                  <z-pcontent
                    ref="zpContent"
                    date="0924"
                    times="1"
                  ></z-pcontent>
                </div>
                <div class="zp-table-box">
                  <z-pcontent
                    ref="zpContent"
                    date="0925"
                    times="2"
                  ></z-pcontent>
                </div>
                <div class="zp-table-box">
                  <z-pcontent
                    ref="zpContent"
                    date="0926"
                    times="2"
                  ></z-pcontent>
                </div>
                <div class="zp-table-box"></div>
                <div class="zp-table-box"></div>
                <div class="zp-table-box">
                  <z-pcontent
                    ref="zpContent"
                    date="0929"
                    times="1"
                  ></z-pcontent>
                </div>
              </div>
              <div class="zp-table-cell">
                <div class="zp-table-column1">
                  <div class="zp-table-info">9/30</div>
                </div>
                <div class="zp-table-column1">
                  <div class="zp-table-info">10/1</div>
                </div>
                <div class="zp-table-column1">
                  <div class="zp-table-info">10/2</div>
                </div>
                <div class="zp-table-column1">
                  <div class="zp-table-info">10/3</div>
                </div>
                <div class="zp-table-column1">
                  <div class="zp-table-info">10/4</div>
                </div>
                <div class="zp-table-column1">
                  <div class="zp-table-info">10/5</div>
                </div>
                <div class="zp-table-column1">
                  <div class="zp-table-info">10/6</div>
                </div>
              </div>
              <div class="zp-table-content">
                <div class="zp-table-box"></div>
                <div class="zp-table-box"></div>
                <div class="zp-table-box"></div>
                <div class="zp-table-box"></div>
                <div class="zp-table-box"></div>
                <div class="zp-table-box"></div>
                <div class="zp-table-box"></div>
              </div>

              <div class="zp-table-cell">
                <div class="zp-table-column1">
                  <div class="zp-table-info">10/7</div>
                </div>
                <div class="zp-table-column1">
                  <div class="zp-table-info">10/8</div>
                </div>
                <div class="zp-table-column1">
                  <div class="zp-table-info">10/9</div>
                </div>
                <div class="zp-table-column1">
                  <div class="zp-table-info">10/10</div>
                </div>
                <div class="zp-table-column1">
                  <div class="zp-table-info">10/11</div>
                </div>
                <div class="zp-table-column1">
                  <div class="zp-table-info">10/12</div>
                </div>
                <div class="zp-table-column1">
                  <div class="zp-table-info">10/13</div>
                </div>
              </div>
              <div class="zp-table-content">
                <div class="zp-table-box"></div>
                <div class="zp-table-box">
                  <z-pcontent
                    ref="zpContent"
                    date="1008"
                    times="1"
                  ></z-pcontent>
                </div>
                <div class="zp-table-box">
                  <z-pcontent
                    ref="zpContent"
                    date="1009"
                    times="1"
                  ></z-pcontent>
                </div>
                <div class="zp-table-box">
                  <z-pcontent
                    ref="zpContent"
                    date="1010"
                    times="2"
                  ></z-pcontent>
                </div>
                <div class="zp-table-box">
                  <z-pcontent
                    ref="zpContent"
                    date="1011"
                    times="2"
                  ></z-pcontent>
                </div>
                <div class="zp-table-box"></div>
                <div class="zp-table-box"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- =========================
       APP DESCRIPTION - 2
  ============================== -->
    <section id="video">
      <video src="./video/video.webm" autoplay loop muted />
      <div class="video-content">
        <img src="./images/systemName.png" class="content-title1" />
        <div class="content-title2">
          <div
            class="t1"
            :class="{ active: flagClick === 0 }"
            @click="flagClickChange(0)"
          >
            薪酬福利待遇
          </div>
          <div
            class="t2"
            :class="{ active: flagClick === 1 }"
            @click="flagClickChange(1)"
          >
            招聘流程
          </div>
          <div
            class="t2"
            :class="{ active: flagClick === 2 }"
            @click="flagClickChange(2)"
          >
            实践生招募流程
          </div>
        </div>
        <div class="content-title3">
          <div id="index2" class="title3Text"></div>
        </div>
        <div class="content-title4">
          <button
            style="
              width: 210px;
              height: 52px;
              border-radius: 28px;
              background: linear-gradient(180deg, #1f62c5 0%, #5d9eff 100%);
              border: none;
              outline: none;
            "
            @click="gotoInfos"
          >
            <a
              style="
                font-size: 24px;
                width: 100px;
                height: 31px;
                color: #ffffff;
              "
              >点击进入<img
                src="./images/sanjiao.png"
                style="margin-left: 20px"
            /></a>
          </button>
        </div>
      </div>
      <div class="video-content2">
        <p
          style="
            font-size: 26px;
            height: 36px;
            color: #ffffff;
            font-weight: 400;
          "
        >
          "国家一流研究院、高端人才聚集地，优秀毕业生就业首选" ——中物院品牌
        </p>
      </div>
    </section>

    <!-- =========================
       APP FEATURE - 2
  ============================== -->

    <!-- =========================
       SERVICES
  ============================== -->
    <section id="service" class="service service-1">
      <div class="container">
        <div class="row">
          <div class="col-md-6 col-md-offset-3">
            <header class="section-heading text-center">
              <p class="title-contact">ABOUT US</p>
              <h2 class="title-text">关于我们</h2>
              <p class="sub-title">中国工程物理研究院概况</p>
            </header>
          </div>
        </div>
        <div class="row">
          <div
            class="service-1-container"
            style="display: flex; justify-content: center"
          >
            <p id="index1">
              &nbsp;&nbsp;中国工程物理研究院(简称中物院，原简称九院)
              创建于1958年，是国家计划单列的我国唯一的核武器研制生产单位，是以发展国防尖端科学技术为主的集理论、实验、设计、生产为一体的综合性研究院。中物院主体座落于四川省绵阳市科学城，在北京、上海、成都等地设有科研分支机构。
              中物院主要从事物理、数学、力学、材料与化学、核科学与技术、兵器科学与技术、机械工程、电子科学与技术、光学工程以及科学工程管理等学科领域的研究及应用、是专业门类齐全、先进设备与技术保障能力相配套的大型科研生产基地。中物院
              “两弹一星功勋奖章”获得者9名，国家最高科学技术奖获得者1名。现有28位院士，45位国家"百千万人才工程"人选，3位中华技能大奖获得者，80位全国技术能手等高素质人才和一大批科技创新团队。
              中物院设有研究生院（北京），6个一级学科博士学位授权点（含17个二级学科博士学位授权点）、4个一级学科硕士学位授权点和2个二级学科硕士学位授权点。拥有物理、力学、数学、核科学与技术、光学工程、材料科学与工程博士后科研流动站（其中核科学与技术、数学和物理学博士后流动站为全国优秀博士后流动站）。
            </p>
            <img
              src="./images/aboutUs.png"
              alt="Phone"
              class="img-responsive img-md-right"
              style="margin-left: 20px"
            />
          </div>
        </div>
      </div>
    </section>
    <!--    <section id="service" class="service service-1">-->
    <!--      <div class="container">-->
    <!--        <div class="row">-->
    <!--          <div-->
    <!--            class="col-md-5 pull-right mb-45"-->
    <!--            data-sr="enter right, move 40px, over 1s"-->
    <!--          >-->
    <!--            <img-->
    <!--              src="./images/dashboard.png"-->
    <!--              alt="Phone"-->
    <!--              class="img-responsive img-md-right"-->
    <!--            />-->
    <!--          </div>-->

    <!--          <div-->
    <!--            class="col-md-7 pull-left mb-45"-->
    <!--            data-sr="enter left, move 40px, over 1s"-->
    <!--          >-->
    <!--            <header class="column-heading text-center">-->
    <!--              &lt;!&ndash;                    <i class="icon icon-basic-rss"></i>&ndash;&gt;-->
    <!--              <h2 class="title-text">中国工程物理研究院概况</h2>-->
    <!--            </header>-->
    <!--            &lt;!&ndash; /.column-heading &ndash;&gt;-->

    <!--            <p id="index1">-->
    <!--              &nbsp;&nbsp;中国工程物理研究院(简称中物院，原简称九院) 创建于1958年，是国家计划单列的我国唯一的核武器研制生产单位，是以发展国防尖端科学技术为主的集理论、实验、设计、生产为一体的综合性研究院。中物院主体座落于四川省绵阳市科学城，在北京、上海、成都等地设有科研分支机构。-->
    <!--              中物院主要从事物理、数学、力学、材料与化学、核科学与技术、兵器科学与技术、机械工程、电子科学与技术、光学工程以及科学工程管理等学科领域的研究及应用、是专业门类齐全、先进设备与技术保障能力相配套的大型科研生产基地。中物院 “两弹一星功勋奖章”获得者9名，国家最高科学技术奖获得者1名。现有28位院士，45位国家"百千万人才工程"人选，3位中华技能大奖获得者，80位全国技术能手等高素质人才和一大批科技创新团队。-->
    <!--              中物院设有研究生院（北京），6个一级学科博士学位授权点（含17个二级学科博士学位授权点）、4个一级学科硕士学位授权点和2个二级学科硕士学位授权点。拥有物理、力学、数学、核科学与技术、光学工程、材料科学与工程博士后科研流动站（其中核科学与技术、数学和物理学博士后流动站为全国优秀博士后流动站）。-->
    <!--            </p>-->
    <!--          </div>-->

    <!--          <div-->
    <!--            class="col-md-5 pull-right mb-45"-->
    <!--            data-sr="enter right, move 40px, over 1s"-->
    <!--          >-->
    <!--            <img-->
    <!--              src="./images/dashboard2.png"-->
    <!--              alt="Phone"-->
    <!--              class="img-responsive img-md-right"-->
    <!--            />-->
    <!--          </div>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </section>-->
    <!-- =========================
     APP DESCRIPTION - 2
============================== -->
    <section id="app-description" class="app-description app-description-2">
      <div class="container">
        <!-- SECTION HEADING -->
        <div class="row">
          <div class="col-md-8 col-md-offset-2 col-sm-10 col-sm-offset-1">
            <header class="section-heading text-center">
              <h3 class="title-text">中物院主要研究领域、需求专业</h3>
              <p class="sub-title">
                中物院共有5大学科领域，100多个研究方向，涉及260余个专业，几乎涵盖了所有理工科专业
              </p>
            </header>
          </div>
        </div>
        <!-- /END SECTION HEADING -->
        <div class="row">
          <div
            class="col-md-4 col-md-offset-0 col-sm-8 col-sm-offset-2 mb-45"
            data-sr="enter left, move 40px, over 1s"
          >
            <div class="service-item text-center">
              <div class="cus-table">
                <div class="cus-table-title">
                  <div class="cus-table-key">所属领域</div>
                  <div class="cus-table-val">需求专业</div>
                </div>
                <div class="cus-table-content">
                  <div class="cus-table-cell">
                    <div class="cus-table-key">数学</div>
                    <div class="cus-table-val">计算数学，应用数学</div>
                  </div>
                  <div class="cus-table-cell">
                    <div class="cus-table-key">物理学</div>
                    <div class="cus-table-val">
                      理论物理,应用物理,物理实验技术,粒子物理与原子核物理,原子与分子物理,等离子体物理,凝聚态物理,光学,无线电物理,电磁学
                    </div>
                  </div>
                  <div class="cus-table-cell">
                    <div class="cus-table-key">化学</div>
                    <div class="cus-table-val">
                      分析化学,物理化学,应用化学,高分子化学与物理,化学工程,化工分析与检测
                    </div>
                  </div>
                  <div class="cus-table-cell">
                    <div class="cus-table-key">力学</div>
                    <div class="cus-table-val">
                      一般力学与力学基础,固体力学,流体力学,工程力学,计算力学,理论力学
                    </div>
                  </div>
                  <div class="cus-table-cell">
                    <div class="cus-table-key">机械工程</div>
                    <div class="cus-table-val">
                      机械制造及其自动化,机械设计及理论,机械制造工艺与设备,机械设计及制造,真空技术及设备,机械电子工程,机电一体化,机械学,仪器仪表技术,液体传动与控制,计算机辅助设计与制造
                    </div>
                  </div>
                  <div class="cus-table-cell">
                    <div class="cus-table-key">光学</div>
                    <div class="cus-table-val">光学工程</div>
                  </div>
                  <div class="cus-table-cell">
                    <div class="cus-table-key">仪器科学与技术</div>
                    <div class="cus-table-val">
                      精密仪器及机械,测试计量技术及仪器
                    </div>
                  </div>
                  <div class="cus-table-cell">
                    <div class="cus-table-key">热能核能工程</div>
                    <div class="cus-table-val">
                      制冷与低温技术,核工程与技术,核反应堆与核电站运行,核技术应用,辐射防护与监测
                    </div>
                  </div>
                  <div class="cus-table-cell">
                    <div class="cus-table-key">电气工程</div>
                    <div class="cus-table-val">
                      高电压与绝缘技术,电气技术与工程,电气工程及其自动化,电力系统及其自动化
                    </div>
                  </div>
                  <div class="cus-table-cell">
                    <div class="cus-table-key">电子科学与技术</div>
                    <div class="cus-table-val">
                      电路与系统,电磁场与微波技术,物理电子学,微电子学与固体电子学,核电子学
                    </div>
                  </div>
                  <div class="cus-table-cell">
                    <div class="cus-table-key">信息与通信工程</div>
                    <div class="cus-table-val">
                      通信与信息系统,信号与信息处理
                    </div>
                  </div>
                  <div class="cus-table-cell">
                    <div class="cus-table-key">控制科学与工程</div>
                    <div class="cus-table-val">
                      控制理论与控制工程,检测技术与自动化装置,系统工程,模式识别与智能系统,导航、制导与工程
                    </div>
                  </div>
                  <div class="cus-table-cell">
                    <div class="cus-table-key">计算机科学与技术</div>
                    <div class="cus-table-val">
                      计算机应用技术,计算机软件与理论,计算机网络,计算机系统结构,计算机科学技术与基础科学,数据安全与计算机安全,模式识别与智能系统,计算机仿真,计算机图像处理,并行处理
                    </div>
                  </div>
                  <div class="cus-table-cell">
                    <div class="cus-table-key">航空宇航科学与技术</div>
                    <div class="cus-table-val">
                      航空宇航推进理论与工程,飞行器总体设计,航天器环境工程
                    </div>
                  </div>
                  <div class="cus-table-cell">
                    <div class="cus-table-key">兵器科学与技术</div>
                    <div class="cus-table-val">
                      火炮、自动武器与弹药工程,武器系统与应用工程,军事化学与烟火技术
                    </div>
                  </div>
                  <div class="cus-table-cell">
                    <div class="cus-table-key">核科学与技术</div>
                    <div class="cus-table-val">
                      核技术与应用,核能科学与工程,核燃料循环与材料,辐射防护及环境保护
                    </div>
                  </div>
                  <div class="cus-table-cell">
                    <div class="cus-table-key">材料科学与工程</div>
                    <div class="cus-table-val">
                      材料科学基础科学,材料表面与界面,材料失效与保护,材料检测与分析技术,材料实验,材料合成与加工工艺,金属材料,复合材料,材料物理与化学,材料学,材料加工工程
                    </div>
                  </div>
                  <div class="cus-table-cell">
                    <div class="cus-table-key">电子、通信与自动控制技术</div>
                    <div class="cus-table-val">
                      电子技术,通信技术,自动控制技术,真空电子技术,计算机与信息管理
                    </div>
                  </div>
                  <div class="cus-table-cell">
                    <div class="cus-table-key">环境科学与工程</div>
                    <div class="cus-table-val">
                      环境学,环境工程,环境监测,环境治理工,环境保护
                    </div>
                  </div>
                  <div class="cus-table-cell">
                    <div class="cus-table-key">化工与制药</div>
                    <div class="cus-table-val">
                      化学工程,化工工艺,生物化工,核化工工艺,工业分析技术
                    </div>
                  </div>
                  <div class="cus-table-cell">
                    <div class="cus-table-key">软件工程</div>
                    <div class="cus-table-val"></div>
                  </div>
                  <div class="cus-table-cell">
                    <div class="cus-table-key">网络空间安全</div>
                    <div class="cus-table-val"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- =========================
       PRICING TABLE
  ============================== -->
    <!--    <section id="pricing-table" class="pricing-table pricing-table-1">-->
    <!--      <div class="overlay">-->
    <!--        <div class="container">-->
    <!--          <div id="zhaopin">-->
    <!--            <div-->
    <!--              class="col-md-6 col-md-offset-0 col-sm-12 col-sm-offset-2 mb-45"-->
    <!--              data-sr="enter left, move 40px, over 1s"-->
    <!--            >-->
    <!--              <div class="single-table active">-->
    <!--                <header>-->
    <!--                  <h5 class="heading">薪酬福利待遇</h5>-->
    <!--                </header>-->

    <!--                <div class="features">-->
    <!--                  <ul class="">-->
    <!--                    <li class="affirmative">-->
    <!--                      作为国家唯一的核武器研制单位，国家给予我院足够重视和支持，我们也将为你的辛勤付出和优秀业绩提供体面的薪酬福利待遇。-->
    <!--                    </li>-->
    <!--                    <li></li>-->
    <!--                  </ul>-->
    <!--                </div>-->
    <!--              </div>-->
    <!--              &lt;!&ndash; /.single-table &ndash;&gt;-->
    <!--            </div>-->
    <!--            <div-->
    <!--              class="col-md-6 col-md-offset-0 col-sm-12 col-sm-offset-2 mb-45"-->
    <!--              data-sr="enter bottom, move 40px, over 1s, wait 0.5s"-->
    <!--            >-->
    <!--              <div class="single-table active">-->
    <!--                <header>-->
    <!--                  <h5 class="heading">招聘流程</h5>-->
    <!--                  &lt;!&ndash;                            <div class="pricing">&ndash;&gt;-->
    <!--                  &lt;!&ndash;                                <span class="currency">$</span>&ndash;&gt;-->
    <!--                  &lt;!&ndash;                                <span class="rate">95</span>&ndash;&gt;-->
    <!--                  &lt;!&ndash;                                <span class="period">/mo</span>&ndash;&gt;-->
    <!--                  &lt;!&ndash;                            </div>&ndash;&gt;-->
    <!--                </header>-->

    <!--                <div class="features">-->
    <!--                  <ul class="">-->
    <!--                    &lt;!&ndash;                  <li class="affirmative">-->
    <!--                      网申投递简历——筛选简历——HR邀请面试——职业能力素质测评——身体健康检查——专家组面试——发offer-->
    <!--                    </li>-->
    <!--                    <li><br /></li>-->
    <!--                    <li>-->
    <!--                      <b-->
    <!--                        >各重点高校也可以单独组织博士团来中物院暑期实践和学术交流。</b-->
    <!--                      >-->
    <!--                    </li>&ndash;&gt;-->
    <!--                    <li class="affirmative">-->
    <!--                      网申投递简历——筛选简历——HR面试——职业能力素质测评——身体健康检查——专家组面试——发offer-->
    <!--                    </li>-->
    <!--                    &lt;!&ndash;                  <li class="affirmative">筛选简历</li>-->
    <!--                    <li class="affirmative">HR面试</li>-->
    <!--                    <li class="affirmative">职业能力素质测评</li>-->
    <!--                    <li class="affirmative">身体健康检查</li>-->
    <!--                    <li class="affirmative">专家组面试</li>-->
    <!--                    <li class="affirmative">发offer</li>&ndash;&gt;-->

    <!--                    &lt;!&ndash;                                <li class="affirmative">Knowledgebase</li>&ndash;&gt;-->
    <!--                    &lt;!&ndash;                                <li class="affirmative">24/7 Dedicated Support</li>&ndash;&gt;-->
    <!--                    &lt;!&ndash;                                <li class="affirmative">Access to Tutorials</li>&ndash;&gt;-->
    <!--                    &lt;!&ndash;                                <li class="affirmative">Daily Auto Backup</li>&ndash;&gt;-->
    <!--                  </ul>-->

    <!--                  &lt;!&ndash;                            <a href="#" class="btn btn-cmd btn-base">Download Now</a>&ndash;&gt;-->
    <!--                </div>-->
    <!--              </div>-->
    <!--              &lt;!&ndash; /.single-table &ndash;&gt;-->
    <!--            </div>-->
    <!--          </div>-->
    <!--          <div id="shijian">-->
    <!--            <div-->
    <!--              class="col-md-12 col-md-offset-0 col-sm-12 col-sm-offset-2 mb-45"-->
    <!--              data-sr="enter left, move 40px, over 1s"-->
    <!--            >-->
    <!--              <div class="single-table active">-->
    <!--                <header>-->
    <!--                  <h5 class="heading">薪酬福利待遇</h5>-->
    <!--                  &lt;!&ndash;                            <div class="pricing">&ndash;&gt;-->
    <!--                  &lt;!&ndash;                                <span class="currency">$</span>&ndash;&gt;-->
    <!--                  &lt;!&ndash;                                <span class="rate">49</span>&ndash;&gt;-->
    <!--                  &lt;!&ndash;                                <span class="period">/mo</span>&ndash;&gt;-->
    <!--                  &lt;!&ndash;                            </div>&ndash;&gt;-->
    <!--                </header>-->

    <!--                <div class="features">-->
    <!--                  <ul class="">-->
    <!--                    <li class="affirmative" id="index2">-->
    <!--                      作为国家唯一的核武器研制单位，国家给予我院足够重视和支持，我们也将为你的辛勤付出和优秀业绩提供体面的薪酬福利待遇。-->
    <!--                    </li>-->
    <!--                    <li></li>-->
    <!--                  </ul>-->

    <!--                  &lt;!&ndash;                            <a href="#" class="btn btn-cmd btn-base-alt">Download Now</a>&ndash;&gt;-->
    <!--                </div>-->
    <!--              </div>-->
    <!--              &lt;!&ndash; /.single-table &ndash;&gt;-->
    <!--            </div>-->
    <!--            <div-->
    <!--              class="col-md-6 col-md-offset-0 col-sm-12 col-sm-offset-2 mb-45"-->
    <!--              data-sr="enter bottom, move 40px, over 1s, wait 0.5s"-->
    <!--            >-->
    <!--              <div class="single-table active">-->
    <!--                <header>-->
    <!--                  <h5 class="heading">招聘流程</h5>-->
    <!--                </header>-->

    <!--                <div class="features">-->
    <!--                  <ul class="">-->
    <!--                    <li class="affirmative" id="index3">-->
    <!--                      网申投递简历——筛选简历——HR面试——职业能力素质测评——身体健康检查——专家组面试——发offer-->
    <!--                    </li>-->
    <!--                  </ul>-->
    <!--                </div>-->
    <!--              </div>-->
    <!--              &lt;!&ndash; /.single-table &ndash;&gt;-->
    <!--            </div>-->
    <!--            <div-->
    <!--              class="col-md-6 col-md-offset-0 col-sm- col-sm-offset-2 mb-45"-->
    <!--              data-sr="enter bottom, move 40px, over 1s, wait 0.5s"-->
    <!--            >-->
    <!--              <div class="single-table active">-->
    <!--                <header>-->
    <!--                  <h5 class="heading">实践生招募流程</h5>-->
    <!--                </header>-->
    <!--                <div class="features">-->
    <!--                  <ul class="">-->
    <!--                    <li class="affirmative" id="index4">-->
    <!--                      网申投递简历（投递到各所实践生岗）——筛选简历——电话与你确认——发邀请函-->
    <!--                    </li>-->
    <!--                  </ul>-->
    <!--                </div>-->
    <!--              </div>-->
    <!--            </div>-->
    <!--          </div>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--      &lt;!&ndash; /.overlay &ndash;&gt;-->
    <!--    </section>-->

    <!-- =========================
       CONTACT
  ============================== -->

    <div id="contact" class="contact">
      <div class="container">
        <!-- SECTION HEADING -->
        <div class="row">
          <div class="col-md-6 col-md-offset-3">
            <header class="section-heading text-center">
              <p class="title-contact">CONTACT US</p>
              <h2 class="title-text">联系我们</h2>
              <p class="sub-title">点击各所标题查看详情</p>
            </header>
          </div>
        </div>
        <!-- /END SECTION HEADING -->

        <div class="row">
          <div class="col-sm-4 mb-45 colContent">
            <h5>
              <a
                id="introduce1link"
                href="#"
                target="_Self"
                class="colContent-title"
                >流体物理研究所 (一所)
              </a>
            </h5>
            <address>
              <p id="introduce1phone1" class="phone">王志文 0816-2481400</p>
              <p id="introduce1phone2" class="phone">邹文康 0816-2484103</p>
              <a id="introduce1email" class="icon-mail-alt"
                >&nbsp;&nbsp;caep1s@caep.cn</a
              >
            </address>
          </div>

          <div class="col-sm-4 mb-45 colContent" style="margin-left: 10px">
            <h5>
              <a id="introduce2link" href="#" target="_Self"
                >核物理与化学研究所 (二所)
              </a>
            </h5>
            <address>
              <p id="introduce2phone1" class="phone">林 涛 0816-2482051</p>
              <p id="introduce2phone2" class="phone">梁建华 0816-2484274</p>
              <a id="introduce2email" class="icon-mail-alt"
                >&nbsp;&nbsp;esrsc@163.com</a
              >
            </address>
          </div>

          <div class="col-sm-4 mb-45 colContent" style="margin-left: 10px">
            <h5>
              <a id="introduce3link" href="#" target="_Self"
                >化工材料研究所 (三所)
              </a>
            </h5>
            <address>
              <p id="introduce3phone1" class="phone">于海江 0816-2485325</p>
              <p id="introduce3phone2" class="phone">宋悦华 0816-2485392</p>
              <a id="introduce3email" class="icon-mail-alt"
                >&nbsp;&nbsp;caep3s@126.com</a
              >
            </address>
          </div>

          <div class="col-sm-4 mb-45 colContent" style="margin-left: 10px">
            <h5>
              <a id="introduce4link" href="#" target="_Self"
                >总体工程研究所 (四所)
              </a>
            </h5>
            <address>
              <p id="introduce4phone1" class="phone">范 瑛 0816-2494978</p>
              <p id="introduce4phone2" class="phone">张 凯 0816-2488785</p>
              <a id="introduce4email" class="icon-mail-alt"
                >&nbsp;&nbsp;fany@caep.cn</a
              >
            </address>
          </div>
        </div>

        <div class="row">
          <!--          <div class="rectangle"></div>-->
          <div class="col-sm-4 mb-45 colContent">
            <h5>
              <a id="introduce5link" href="#" target="_Self"
                >电子工程研究所 (五所)
              </a>
            </h5>
            <address>
              <p id="introduce5phone1" class="phone">王建川 0816-2487507</p>
              <p id="introduce5phone2" class="phone">赫英毅 0816-2487555</p>
              <a id="introduce5email" class="icon-mail-alt"
                >&nbsp;&nbsp;iee7507@163.com</a
              >
            </address>
          </div>

          <!--          <div class="rectangle"></div>-->
          <div class="col-sm-4 mb-45 colContent" style="margin-left: 10px">
            <h5>
              <a id="introduce6link" href="#" target="_Self"
                >机械制造工艺研究所 (六所)
              </a>
            </h5>
            <address>
              <p id="introduce6phone1" class="phone">卢晓冬 0816-2484691</p>
              <p id="introduce6phone2" class="phone">周朝辉 0816-2494857</p>
              <a id="introduce6email" class="icon-mail-alt"
                >&nbsp;&nbsp;zwy6s@qq.com</a
              >
            </address>
          </div>

          <div class="col-sm-4 mb-45 colContent" style="margin-left: 10px">
            <h5>
              <a id="introduce7link" href="#" target="_Self"
                >材料研究所 (七所)
              </a>
            </h5>
            <address>
              <p id="introduce7phone1" class="phone">刘 凯 0816-3620235</p>
              <p id="introduce7phone2" class="phone">陈晓谋 0816-3620230</p>
              <a id="introduce7email" class="icon-mail-alt"
                >&nbsp;&nbsp;caep7hr@163.com</a
              >
            </address>
          </div>

          <div class="col-sm-4 mb-45 colContent" style="margin-left: 10px">
            <h5>
              <a id="introduce8link" href="#" target="_Self"
                >激光聚变研究中心 (八所)
              </a>
            </h5>
            <address>
              <p id="introduce8phone1" class="phone">漆自名 0816-2484273</p>
              <p id="introduce8phone2" class="phone">刘益军 0816-2494945</p>
              <a id="introduce8email" class="icon-mail-alt"
                >&nbsp;&nbsp;caep8s@163.com</a
              >
            </address>
          </div>
        </div>

        <div class="row">
          <!--          <div class="rectangle"></div>-->
          <div class="col-sm-4 mb-45 colContent">
            <h5>
              <a id="introduce9link" href="#" target="_Self"
                >北京应用物理与计算数学研究所（九所）
              </a>
            </h5>
            <address>
              <p id="introduce9phone1" class="phone">敢旭玫 010-59872593</p>
              <p id="introduce9phone2" class="phone">邬 林 010-59872342</p>
              <p id="introduce9phone3" class="phone">白 云 010-59872530</p>
              <a id="introduce9email" class="icon-mail-alt"
                >&nbsp;&nbsp;ganxumei@163.com</a
              >
            </address>
          </div>

          <!--          <div class="rectangle"></div>-->
          <div class="col-sm-4 mb-45 colContent" style="margin-left: 10px">
            <h5>
              <a id="introduce10link" href="#" target="_Self"
                >应用电子学研究所 (十所)
              </a>
            </h5>
            <address>
              <p id="introduce10phone1" class="phone">邓国华 0816-2485558</p>
              <p id="introduce10phone2" class="phone">李旭东 0816-2484562</p>
              <a id="introduce10email" class="icon-mail-alt"
                >&nbsp;&nbsp;993941619@qq.com</a
              >
            </address>
          </div>

          <div class="col-sm-4 mb-45 colContent" style="margin-left: 10px">
            <h5>
              <a id="introduce11link" href="#" target="_Self"
                >上海激光等离子体研究所 (十一所)
              </a>
            </h5>
            <address>
              <p id="introduce11phone1" class="phone">周华珍 021-59927782</p>
              <p id="introduce11phone2" class="phone">孟祥富 021-59528968</p>
              <a id="introduce11email" class="icon-mail-alt"
                >&nbsp;&nbsp;suoban1129@126.com</a
              >
            </address>
          </div>

          <div class="col-sm-4 mb-45 colContent" style="margin-left: 10px">
            <h5>
              <a id="introduce12link" href="#" target="_Self"
                >计算机应用研究所 (十二所)
              </a>
            </h5>
            <address>
              <p id="introduce12phone1" class="phone">豆思远 0816-2491959</p>
              <p id="introduce12phone2" class="phone">汪 旭 0816-2495915</p>
              <a id="introduce12emial" class="icon-mail-alt"
                >&nbsp;&nbsp;icahr12caep@163.com</a
              >
            </address>
          </div>
        </div>

        <div class="row">
          <!--          <div class="rectangle"></div>-->
          <div class="col-sm-4 mb-45 colContent">
            <h5>
              <a id="introduce13link" href="#" target="_Self"
                >科技信息中心 (信息中心)
              </a>
            </h5>
            <address>
              <p id="introduce13phone1" class="phone">王立楠 0816-2483701</p>
              <p id="introduce13phone2" class="phone">肖 燕 0816-2495199</p>
              <a id="introduce13email" class="icon-mail-alt"
                >&nbsp;&nbsp;33928161@qq.com</a
              >
            </address>
          </div>

          <!--          <div class="rectangle"></div>-->
          <div class="col-sm-4 mb-45 colContent" style="margin-left: 10px">
            <h5>
              <a id="introduce14link" href="#" target="_Self"
                >计量测试中心 (计测中心)
              </a>
            </h5>
            <address>
              <p id="introduce14phone1" class="phone">孙 昉 0816-2482276</p>
              <p id="introduce14phone2" class="phone">张力元 0816-2494796</p>
              <a id="introduce14email" class="icon-mail-alt"
                >&nbsp;&nbsp;caepjczxzp@163.com</a
              >
            </address>
          </div>

          <div class="col-sm-4 mb-45 colContent" style="margin-left: 10px">
            <h5>
              <a id="introduce15link" href="#" target="_Self"
                >中物院高性能数值模拟软件中心
              </a>
            </h5>
            <address>
              <p id="introduce15phone1" class="phone">朱景焕 010-61935712</p>
              <p id="introduce15phone2" class="phone">王娜 010-61935700</p>
              <a id="introduce15email" class="icon-mail-alt"
                >&nbsp;&nbsp;rjzx@iapcm.ac.cn</a
              >
            </address>
          </div>

          <div class="col-sm-4 mb-45 colContent" style="margin-left: 10px">
            <h5>
              <a id="introduce16link" href="#" target="_Self"
                >中物院战略技术装备发展中心
              </a>
            </h5>
            <address>
              <p id="introduce16phone1" class="phone">马 莉 0816-2497100</p>
              <p id="introduce16phone2" class="phone">马 莉 0816-2497100</p>
              <a id="introduce16email" class="icon-mail-alt"
                >&nbsp;&nbsp;chinajiuyuan@126.com</a
              >
            </address>
          </div>
        </div>

        <div class="row">
          <!--          <div class="rectangle"></div>-->
          <div class="col-sm-4 mb-45 colContent">
            <h5>
              <a id="introduce17link" href="#" target="_Self"
                >中物院科研保障中心 (科保中心)
              </a>
            </h5>
            <address>
              <p id="introduce17phone1" class="phone">xxx</p>
              <p id="introduce17phone2" class="phone">xxx</p>
              <a id="introduce17email" class="icon-mail-alt">&nbsp;&nbsp;xxx</a>
            </address>
          </div>

          <div class="col-sm-4 mb-45 colContent" style="margin-left: 10px">
            <h5>
              <a id="introduce18link" href="#" target="_Self"
                >国家工程物理交叉科学研究中心
              </a>
            </h5>
            <address>
              <p id="introduce18phone1" class="phone">张老师 0816-8013777</p>
              <p id="introduce18phone2" class="phone">韩老师 0816-8013000</p>
              <a id="introduce18email" class="icon-mail-alt"
                >&nbsp;&nbsp;nic_hr@163.com</a
              >
            </address>
          </div>

          <div class="col-sm-4 mb-45 colContent" style="margin-left: 10px">
            <h5>
              <a id="introduce19link" href="#" target="_Self"
                >中国工程物理研究院研究生院
              </a>
            </h5>
            <address>
              <p id="introduce19phone1" class="phone">张老师 010-56989385</p>
              <p id="introduce19phone2" class="phone">平老师 010-56989381</p>
              <a id="introduce19email" class="icon-mail-alt"
                >&nbsp;&nbsp;zhangwb@gscaep.ac.cn</a
              >
            </address>
          </div>
        </div>
      </div>
    </div>

    <section>
      <div class="rowContent">
        <p class="content1">
          如果每一位来到中物院的年轻人都是一粒怀揣梦想的种子，中物院便是最肥沃的土壤。
        </p>
        <p class="content2">
          只要你敢于梦想、勇于追梦、勤于圆梦，中物院定能助力有准备的你梦想成真，在拼搏的青春中为核武器科技事业的发展贡献力量。
        </p>
        <p class="content3">热烈欢迎莘莘学子加盟国防事业，成就科研梦想</p>
      </div>
    </section>

    <section>
      <div class="bottomGrounp">
        <div class="bottomInfo">
          <p class="bottom-title">敬请关注</p>
          <p>
            登录中物院网站:<a href="https://www.caep.cn">www.caep.cn</a
            >了解中物院概况;
          </p>
          <p>
            登录中物院人才招聘网:<a href="https://zpxx.caep.cn">zpxx.caep.cn</a
            >了解中物院人才招聘需求;
          </p>
          <p>
            登录中物院素质测评网站:<a href="https://cepin.caepk.net"
              >cepin.caeplc.net</a
            >进行素质测评;
          </p>
          <p>关注中物院微信公众号:中物院曙光视点（zwysgsd）,了解中物院动态。</p>
        </div>
      </div>
    </section>

    <!--    <footer class="footer">-->
    <!--      <div class="container">-->
    <!--        <p class="copyright text-center">-->
    <!--          Copyright &copy; 2021.中国工程物理研究院 since 2018. All Rights-->
    <!--          Reserved.-->
    <!--          <a href="http://beian.miit.gov.cn"> [蜀ICP备11018116号]</a>-->
    <!--        </p>-->
    <!--      </div>-->
    <!--    </footer>-->
    <!--    <show-dialog ref="showDialog"></show-dialog>-->
    <!--    <z-pcontent ref="zpContent"></z-pcontent>-->
  </div>
</template>

<script>
import $ from "jquery";
import "./js/bootstrap.min.js";
import { initCarousel } from "./js/owl.carousel.min.js";
import { initLighrbox } from "./js/nivo-lightbox.min.js";
import { initfitvids } from "@/views/recruit/yuanDesc/js/jquery.fitvids";
import { initSmoothscroll } from "./js/smoothscroll.js";
import { initMedia } from "./js/matchMedia.js";
import { initNav } from "@/views/recruit/yuanDesc/js/jquery.nav";

import { initChimp } from "./js/jquery.ajaxchimp.min.js";
import { initVideo } from "./js/jquery.videoBG.js";

import { initApplication } from "@/views/recruit/yuanDesc/js/application";
import ZPcontent from "@/views/recruit/yuanDesc/zpContent";
// import showDialog from "@/views/recruit/yuanDesc/showDialog";
import { mapGetters } from "vuex";
import { getBasicData } from "@api/job/postInfo";
export default {
  name: "Index",
  components: { ZPcontent },
  data() {
    return {
      indexIntroduceData: {},
      introduce1: {
        phone1: "111",
        phone2: "",
        email: "",
      },
      introduce2: {
        phone1: "",
        phone2: "",
        email: "",
      },
      flagClick: 0,
    };
  },
  computed: {
    ...mapGetters({
      device: "settings/device",
    }),
  },
  watch: {
    flagClick: {
      handler: function (v) {
        console.log("this.indexIntroduceData", this.indexIntroduceData);
        if (v === 0) {
          $("#index2").text(this.indexIntroduceData.data[1].remark);
        } else if (v === 1) {
          $("#index2").text(this.indexIntroduceData.data[2].remark);
        } else {
          $("#index2").text(this.indexIntroduceData.data[3].remark);
        }
      },
    },
  },
  mounted() {
    let date = new Date();
    let currentYear = date.getFullYear();
    $("#currentYear").text(currentYear);
    if (this.device == "mobile") {
      document
        .getElementsByTagName("body")[0]
        .style.setProperty("--main-width", "100%");
      document
        .getElementsByTagName("body")[0]
        .style.setProperty("--left-menu-width", "0px");
    } else {
      $("#info1").hide();
    }
    window.jQuery = $;
    initCarousel($);
    initLighrbox($, window, document);
    initfitvids($ || window.Zepto);
    initSmoothscroll();
    initMedia();
    initNav($, window, document);
    initChimp($);
    initVideo($);
    initApplication();
    // 从数据字典加载联系方式及链接
    this.setDeptConnections();
  },
  methods: {
    flagClickChange(data) {
      this.flagClick = data;
    },
    isPhone() {
      if (screen.availWidth < 1000) {
        return true;
      }
      return false;
    },

    // isPC() {
    //   if (screen.availWidth < 1000) {
    //     return false;
    //   }
    //   return true;
    // },

    gotoInfos() {
      this.$router.push("/recruitInfo/index");
    },
    // 各所联系方式加载数据字典
    async setDeptConnections() {
      //首页简介index
      let indexIntroduce = await getBasicData({ typeCode: "indexIntroduce" });
      console.log("indexIntroduce", indexIntroduce);
      this.indexIntroduceData = indexIntroduce;
      if (indexIntroduce.success) {
        if (indexIntroduce.data[0] && indexIntroduce.data[0].name)
          $("#index1").text(indexIntroduce.data[0].remark);
      } else {
        this.$message.error(indexIntroduce.message);
      }
      if (indexIntroduce.success) {
        if (indexIntroduce.data[1] && indexIntroduce.data[1].name)
          $("#index2").text(indexIntroduce.data[1].remark);
      } else {
        this.$message.error(indexIntroduce.message);
      }
      if (indexIntroduce.success) {
        if (indexIntroduce.data[2] && indexIntroduce.data[2].name) {
          console.log("-----------");
          $("#index3").text(indexIntroduce.data[2].remark);
        }
      } else {
        this.$message.error(indexIntroduce.message);
      }
      if (indexIntroduce.success) {
        if (indexIntroduce.data[3] && indexIntroduce.data[3].name)
          $("#index4").text(indexIntroduce.data[3].remark);
      } else {
        this.$message.error(indexIntroduce.message);
      }
      // 首页标题
      let res = await getBasicData({ typeCode: "introduce" });
      if (res.success) {
        if (res.data[0] && res.data[0].remark) {
          $("#title1").text(res.data[0].remark);
        }
        if (res.data[1] && res.data[1].remark) {
          $("#zhaopin").hide();
          $("#title2").text(res.data[1].remark);
        } else {
          $("#shijian").hide();
        }
        if (res.data[2] && res.data[2].remark) {
          $("#title3").text(res.data[2].remark);
          //  $("#title3").html('<a style="color:red;">'+res.data[2].remark+'</a>');
        }
      } else {
        this.$message.error(res.message);
      }
      let res1 = await getBasicData({ typeCode: "introduce1" });
      if (res1.success) {
        if (res1.data[0] && res1.data[0].name)
          $("#introduce1phone1").text(res1.data[0].name);
        if (res1.data[1] && res1.data[1].name)
          $("#introduce1phone2").text(res1.data[1].name);
        if (res1.data[2] && res1.data[2].name)
          $("#introduce1email").text(" " + res1.data[2].name);
        if (res1.data[res1.data.length - 1].name)
          $("#introduce1link").attr(
            "href",
            res1.data[res1.data.length - 1].name
          );
        if (res1.data[res1.data.length - 1].nameForShort)
          $("#introduce1link").text(
            res1.data[res1.data.length - 1].nameForShort
          );
      } else {
        this.$message.error(res1.message);
      }
      let res2 = await getBasicData({ typeCode: "introduce2" });
      if (res2.success) {
        if (res2.data[0] && res2.data[0].name)
          $("#introduce2phone1").text(res2.data[0].name);
        if (res2.data[1] && res2.data[1].name)
          $("#introduce2phone2").text(res2.data[1].name);
        if (res2.data[2] && res2.data[2].name)
          $("#introduce2email").text(" " + res2.data[2].name);
        if (res2.data[res2.data.length - 1].name)
          $("#introduce2link").attr(
            "href",
            res2.data[res2.data.length - 1].name
          );
        if (res2.data[res2.data.length - 1].nameForShort)
          $("#introduce2link").text(
            res2.data[res2.data.length - 1].nameForShort
          );
      } else {
        this.$message.error(res2.message);
      }
      let res3 = await getBasicData({ typeCode: "introduce3" });
      if (res3.success) {
        if (res3.data[0] && res3.data[0].name)
          $("#introduce3phone1").text(res3.data[0].name);
        if (res3.data[1] && res3.data[1].name)
          $("#introduce3phone2").text(res3.data[1].name);
        if (res3.data[2] && res3.data[2].name)
          $("#introduce3email").text(" " + res3.data[2].name);
        if (res3.data[res3.data.length - 1].name)
          $("#introduce3link").attr(
            "href",
            res3.data[res3.data.length - 1].name
          );
        if (res3.data[res3.data.length - 1].nameForShort)
          $("#introduce3link").text(
            res3.data[res3.data.length - 1].nameForShort
          );
      } else {
        this.$message.error(res3.message);
      }
      let res4 = await getBasicData({ typeCode: "introduce4" });
      if (res4.success) {
        if (res4.data[0] && res4.data[0].name)
          $("#introduce4phone1").text(res4.data[0].name);
        if (res4.data[1] && res4.data[1].name)
          $("#introduce4phone2").text(res4.data[1].name);
        if (res4.data[2] && res4.data[2].name)
          $("#introduce4email").text(" " + res4.data[2].name);
        if (res4.data[res4.data.length - 1].name)
          $("#introduce4link").attr(
            "href",
            res4.data[res4.data.length - 1].name
          );
        if (res4.data[res4.data.length - 1].nameForShort)
          $("#introduce4link").text(
            res4.data[res4.data.length - 1].nameForShort
          );
      } else {
        this.$message.error(res4.message);
      }
      let res5 = await getBasicData({ typeCode: "introduce5" });
      if (res5.success) {
        if (res5.data[0] && res5.data[0].name)
          $("#introduce5phone1").text(res5.data[0].name);
        if (res5.data[1] && res5.data[1].name && res5.data[1].name !== "null")
          $("#introduce5phone2").text(res5.data[1].name);
        else {
          $("#introduce5phone2").hide();
        }
        if (res5.data[2] && res5.data[2].name)
          $("#introduce5email").text(" " + res5.data[2].name);
        if (res5.data[res5.data.length - 1].name)
          $("#introduce5link").attr(
            "href",
            res5.data[res5.data.length - 1].name
          );
        if (res5.data[res5.data.length - 1].nameForShort)
          $("#introduce5link").text(
            res5.data[res5.data.length - 1].nameForShort
          );
      } else {
        this.$message.error(res5.message);
      }
      let res6 = await getBasicData({ typeCode: "introduce6" });
      if (res6.success) {
        if (res6.data[0] && res6.data[0].name)
          $("#introduce6phone1").text(res6.data[0].name);
        if (res6.data[1] && res6.data[1].name)
          $("#introduce6phone2").text(res6.data[1].name);
        if (res6.data[2] && res6.data[2].name)
          $("#introduce6email").text(" " + res6.data[2].name);
        if (res6.data[res6.data.length - 1].name)
          $("#introduce6link").attr(
            "href",
            res6.data[res6.data.length - 1].name
          );
        if (res6.data[res6.data.length - 1].nameForShort)
          $("#introduce6link").text(
            res6.data[res6.data.length - 1].nameForShort
          );
      } else {
        this.$message.error(res5.message);
      }
      let res7 = await getBasicData({ typeCode: "introduce7" });
      if (res7.success) {
        if (res7.data[0] && res7.data[0].name)
          $("#introduce7phone1").text(res7.data[0].name);
        if (res7.data[1] && res7.data[1].name)
          $("#introduce7phone2").text(res7.data[1].name);
        if (res7.data[2] && res7.data[2].name)
          $("#introduce7email").text(" " + res7.data[2].name);
        if (res7.data[res7.data.length - 1].name)
          $("#introduce7link").attr(
            "href",
            res7.data[res7.data.length - 1].name
          );
        if (res7.data[res7.data.length - 1].nameForShort)
          $("#introduce7link").text(
            res7.data[res7.data.length - 1].nameForShort
          );
      } else {
        this.$message.error(res7.message);
      }
      let res8 = await getBasicData({ typeCode: "introduce8" });
      if (res8.success) {
        if (res8.data[0] && res8.data[0].name)
          $("#introduce8phone1").text(res8.data[0].name);
        if (res8.data[1] && res8.data[1].name)
          $("#introduce8phone2").text(res8.data[1].name);
        if (res8.data[2] && res8.data[2].name)
          $("#introduce8email").text(" " + res8.data[2].name);
        if (res8.data[res8.data.length - 1].name)
          $("#introduce8link").attr(
            "href",
            res8.data[res8.data.length - 1].name
          );
        if (res8.data[res8.data.length - 1].nameForShort)
          $("#introduce8link").text(
            res8.data[res8.data.length - 1].nameForShort
          );
      } else {
        this.$message.error(res8.message);
      }
      let res9 = await getBasicData({ typeCode: "introduce9" });
      if (res9.success) {
        if (res9.data[0] && res9.data[0].name)
          $("#introduce9phone1").text(res9.data[0].name);
        if (res9.data[1] && res9.data[1].name)
          $("#introduce9phone2").text(res9.data[1].name);
        if (res9.data[2] && res9.data[2].name && res9.data[2].name !== "null") {
          $("#introduce9phone3").text(res9.data[2].name);
        } else {
          $("#introduce9phone3").hide();
        }
        if (res9.data[3] && res9.data[3].name)
          $("#introduce9email").text(" " + res9.data[3].name);
        if (res9.data[res9.data.length - 1].name)
          $("#introduce9link").attr(
            "href",
            res9.data[res9.data.length - 1].name
          );
        if (res9.data[res9.data.length - 1].nameForShort)
          $("#introduce9link").text(
            res9.data[res9.data.length - 1].nameForShort
          );
      } else {
        this.$message.error(res9.message);
      }
      let res10 = await getBasicData({ typeCode: "introduce10" });
      if (res10.success) {
        if (res10.data[0] && res10.data[0].name)
          $("#introduce10phone1").text(res10.data[0].name);
        if (res10.data[1] && res10.data[1].name)
          $("#introduce10phone2").text(res10.data[1].name);
        if (res10.data[2] && res10.data[2].name)
          $("#introduce10email").text(" " + res10.data[2].name);
        if (res10.data[res10.data.length - 1].name)
          $("#introduce10link").attr(
            "href",
            res10.data[res10.data.length - 1].name
          );
        if (res10.data[res10.data.length - 1].nameForShort)
          $("#introduce10link").text(
            res10.data[res10.data.length - 1].nameForShort
          );
      } else {
        this.$message.error(res10.message);
      }
      let res11 = await getBasicData({ typeCode: "introduce11" });
      if (res11.success) {
        if (res11.data[0] && res11.data[0].name)
          $("#introduce11phone1").text(res11.data[0].name);
        if (res11.data[1] && res11.data[1].name)
          $("#introduce11phone2").text(res11.data[1].name);
        if (res11.data[2] && res11.data[2].name)
          $("#introduce11email").text(" " + res11.data[2].name);
        if (res11.data[res11.data.length - 1].name)
          $("#introduce11link").attr(
            "href",
            res11.data[res11.data.length - 1].name
          );
        if (res11.data[res11.data.length - 1].nameForShort)
          $("#introduce11link").text(
            res11.data[res11.data.length - 1].nameForShort
          );
      } else {
        this.$message.error(res11.message);
      }
      let res12 = await getBasicData({ typeCode: "introduce12" });
      if (res12.success) {
        if (res12.data[0] && res12.data[0].name)
          $("#introduce12phone1").text(res12.data[0].name);
        if (res12.data[1] && res12.data[1].name)
          $("#introduce12phone2").text(res12.data[1].name);
        if (res12.data[2] && res12.data[2].name)
          $("#introduce12email").text(" " + res12.data[2].name);
        if (res12.data[res12.data.length - 1].name)
          $("#introduce12link").attr(
            "href",
            res12.data[res12.data.length - 1].name
          );
        if (res12.data[res12.data.length - 1].nameForShort)
          $("#introduce12link").text(
            res12.data[res12.data.length - 1].nameForShort
          );
      } else {
        this.$message.error(res12.message);
      }
      let res13 = await getBasicData({ typeCode: "introduce13" });
      if (res13.success) {
        if (res13.data[0] && res13.data[0].name)
          $("#introduce13phone1").text(res13.data[0].name);
        if (res13.data[1] && res13.data[1].name)
          $("#introduce13hone2").text(res13.data[1].name);
        if (res13.data[2] && res13.data[2].name)
          $("#introduce13email").text(" " + res13.data[2].name);
        if (res13.data[res13.data.length - 1].name)
          $("#introduce13link").attr(
            "href",
            res13.data[res13.data.length - 1].name
          );
        if (res13.data[res13.data.length - 1].nameForShort)
          $("#introduce13link").text(
            res13.data[res13.data.length - 1].nameForShort
          );
      } else {
        this.$message.error(res13.message);
      }
      let res14 = await getBasicData({ typeCode: "introduce14" });
      if (res14.success) {
        if (res14.data[0] && res14.data[0].name)
          $("#introduce14phone1").text(res14.data[0].name);
        if (res14.data[1] && res14.data[1].name)
          $("#introduce14phone2").text(res14.data[1].name);
        if (res14.data[2] && res14.data[2].name)
          $("#introduce14email").text(" " + res14.data[2].name);
        if (res14.data[res14.data.length - 1].name)
          $("#introduce14link").attr(
            "href",
            res14.data[res14.data.length - 1].name
          );
        if (res14.data[res14.data.length - 1].nameForShort)
          $("#introduce14link").text(
            res14.data[res14.data.length - 1].nameForShort
          );
      } else {
        this.$message.error(res14.message);
      }
      let res15 = await getBasicData({ typeCode: "introduce15" });
      if (res15.success) {
        if (res15.data[0] && res15.data[0].name)
          $("#introduce15phone1").text(res15.data[0].name);
        if (res15.data[1] && res15.data[1].name)
          $("#introduce15phone2").text(res15.data[1].name);
        if (res15.data[2] && res15.data[2].name)
          $("#introduce15email").text(" " + res15.data[2].name);
        if (res15.data[res15.data.length - 1].name)
          $("#introduce15link").attr(
            "href",
            res15.data[res15.data.length - 1].name
          );
        if (res15.data[res15.data.length - 1].nameForShort)
          $("#introduce15link").text(
            res15.data[res15.data.length - 1].nameForShort
          );
      } else {
        this.$message.error(res15.message);
      }
      let res16 = await getBasicData({ typeCode: "introduce16" });
      if (res16.success) {
        if (res16.data[0] && res16.data[0].name)
          $("#introduce16phone1").text(res16.data[0].name);
        if (
          res16.data[1] &&
          res16.data[1].name &&
          res16.data[1].name !== "null"
        ) {
          $("#introduce16phone2").text(res16.data[1].name);
        } else {
          $("#introduce16phone2").hide();
        }
        if (res16.data[2] && res16.data[2].name)
          $("#introduce16email").text(" " + res16.data[2].name);
        if (res16.data[res16.data.length - 1].name)
          $("#introduce16link").attr(
            "href",
            res16.data[res16.data.length - 1].name
          );
        if (res16.data[res16.data.length - 1].nameForShort)
          $("#introduce16link").text(
            res16.data[res16.data.length - 1].nameForShort
          );
      } else {
        this.$message.error(res16.message);
      }
      let res17 = await getBasicData({ typeCode: "introduce17" });
      if (res17.success) {
        if (res17.data[0] && res17.data[0].name)
          $("#introduce17phone1").text(res17.data[0].name);
        if (res17.data[1] && res17.data[1].name)
          $("#introduce17phone2").text(res17.data[1].name);
        if (res17.data[2] && res17.data[2].name)
          $("#introduce17email").text(" " + res17.data[2].name);
        if (res17.data[res17.data.length - 1].name)
          $("#introduce17link").attr(
            "href",
            res17.data[res17.data.length - 1].name
          );
        if (res17.data[res17.data.length - 1].nameForShort)
          $("#introduce17link").text(
            res17.data[res17.data.length - 1].nameForShort
          );
      } else {
        this.$message.error(res17.message);
      }

      let res18 = await getBasicData({ typeCode: "introduce18" });
      if (res18.success) {
        if (res18.data[0] && res18.data[0].name)
          $("#introduce18phone1").text(res18.data[0].name);
        if (res18.data[1] && res18.data[1].name)
          $("#introduce18phone2").text(res18.data[1].name);
        if (res18.data[2] && res18.data[2].name)
          $("#introduce18email").text(" " + res18.data[2].name);
        if (res18.data[res18.data.length - 1].name)
          $("#introduce18link").attr(
            "href",
            res18.data[res18.data.length - 1].name
          );
        if (res18.data[res18.data.length - 1].nameForShort)
          $("#introduce18link").text(
            res18.data[res18.data.length - 1].nameForShort
          );
      } else {
        this.$message.error(res18.message);
      }

      let res19 = await getBasicData({ typeCode: "introduce19" });
      if (res19.success) {
        if (res19.data[0] && res19.data[0].name)
          $("#introduce19phone1").text(res19.data[0].name);
        if (res19.data[1] && res19.data[1].name)
          $("#introduce19phone2").text(res19.data[1].name);
        if (res19.data[2] && res19.data[2].name)
          $("#introduce19email").text(" " + res19.data[2].name);
        if (res19.data[res19.data.length - 1].name)
          $("#introduce19link").attr(
            "href",
            res19.data[res19.data.length - 1].name
          );
        if (res19.data[res19.data.length - 1].nameForShort)
          $("#introduce19link").text(
            res19.data[res19.data.length - 1].nameForShort
          );
      } else {
        this.$message.error(res19.message);
      }
    },
  },
};
</script>

<style scoped lang="css">
@import "./css/bootstrap.min.css";
@import "./css/bootstrap-theme.min.css";
@import "./icons/styles.css";
@import "./css/owl.carousel.css";
@import "./css/owl.theme.green.css";
@import "./css/nivo-lightbox.css";
@import "./css/themes/default/default.css";
@import "./css/style.css";
@import "./css/responsive.css";
@import "./css/colors/blue.css";
</style>

<style scoped lang="scss">
@import "./scss/baseMain";
.rowContent {
  background-image: url(./images/rowBacGround.png);
  background-size: 101% 100%;
  width: 100%;
  height: 336px;
  border-radius: 0px 0px 0px 0px;
  opacity: 0.6;
  text-align: center;
  font-size: 22px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-position: -11px;
  .content1 {
    color: #170606;
  }
  .content2 {
    color: #170606;
  }
  .content3 {
    color: #1f62c5;
  }
}
.bottomGrounp {
  background-image: url(./images/bottomBakgroup.png);
  width: 100%;
  height: 318px;
  border-radius: 0px 0px 0px 0px;
  opacity: 0.7;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
.bottomInfo {
  //.bottom-title{
  //  text-align: left;
  //}
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 60px;
}
.bottom-title {
  text-align: left;
  margin-bottom: 30px;
}
.title-contact {
  width: 670px;
  height: 132px;
  font-size: 100px;
  color: #e9e9e2;
  text-align: center;
  font-style: normal;
  text-transform: none;
}
.sub-title {
  font-size: 16px;
  color: #333333;
}
.rectangle {
  width: 285px;
  height: 5px;
  background: #3682e9 100%;
}
.colContent {
  box-sizing: border-box;
  width: 285px;
  height: 159px;
  offset: 0px 5px;
  effect: 18px 1px;
  background: rgba(0, 0, 0, 0.05);
  padding: 20px;
  border-radius: 10px;
  overflow: hidden;
  position: relative;
  .phone {
    padding-left: 24px;
    background: url(./images/tel.png);
    background-repeat: no-repeat;
    background-position: center left;
  }
  .icon-mail-alt {
    color: #333;
  }
  & > h5 {
    margin-bottom: 15px;
    & > a {
      font-weight: bold;
    }
  }
  &:before {
    content: "";
    display: block;
    width: 285px;
    height: 5px;
    background: #3682e9;
    position: absolute;
    top: 0;
    left: 0;
  }
}
.zpContent {
  box-sizing: border-box;
  width: 167px;
  height: 60px;
  background: #dce5ff;
  display: flex;
  justify-content: center;
}
.app-description {
  background-image: url(./images/header2Background.png);
}

.cus-table {
  width: 1200px;
  max-width: 1200px;
  &-title {
    background: #e7edff;
    display: flex;
    align-items: center;
    height: 55px;
    width: 100%;
  }
  &-key {
    width: 300px;
  }
  &-content {
    height: 500px;
    overflow: hidden;
    overflow-y: auto;
  }
  &-cell {
    display: flex;
    align-items: center;
    height: 55px;
    width: 100%;
    background: #fff;
    &:nth-child(2n) {
      background: #f0f2f7;
    }
  }
}
#video {
  width: 100%;
  height: 900px;
  position: relative;
  margin-top: 20px;
  & > video {
    width: 100%;
    height: 100%;
  }
  .video-content {
    width: 1200px;
    height: 480px;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    background: rgba(0, 0, 0, 0.5);
    text-align: center;
    .content-title1 {
      padding-top: 74px;
    }
    .content-title2 {
      padding-top: 25px;
      display: flex;
      justify-content: center;
    }
    .content-title3 {
      padding-top: 29px;
      .title3Text {
        color: #ffffff;
        padding: 3px;
      }
    }
    .content-title4 {
      padding-top: 35px;
    }
  }

  .t1 {
    width: 164px;
    height: 44px;
    border: 0.5px solid #ffffff;
    font-size: 16px;
    padding: 10px;
    cursor: pointer;
    &.active {
      background: #f5f7fa;
      color: #000;
    }
  }
  .t2 {
    width: 164px;
    height: 44px;
    border: 0.5px solid #ffffff;
    font-size: 16px;
    padding: 10px;
    cursor: pointer;
    &.active {
      background: #f5f7fa;
      color: #000;
    }
  }

  .video-content2 {
    width: 95%;
    height: 80px;
    position: absolute;
    bottom: 0px;
    background: #000;
    padding-top: 15px;
    text-align: center;
    opacity: 0.5;
    left: 0;
    right: 0;
    margin: auto;
  }
}
.zp-table {
  width: 1200px;
  max-width: 1200px;
  &-title {
    width: 100%;
    background: #e7edff;
    display: flex;
    justify-content: center;
  }
  &-cell {
    width: 100%;
    background: #fbf7e6;
    display: flex;
    justify-content: center;
    outline: 0.1px solid #c7d2f2;
  }
  &-content {
    width: 100%;
    display: flex;
    justify-content: center;
    outline: 0.1px solid #c7d2f2;
  }
  &-doubleBox {
    width: 200px;
    height: 70px;
    text-align: center;
    outline: 0.1px solid #c7d2f2;
    .other {
      text-align: center;
      margin-top: 205px;
      font-weight: bold;
      font-size: 14px;
    }
  }
  //&-doubleBox {
  //  width: 200px;
  //  height: 410px;
  //  text-align: left;
  //  outline: 0.1px solid #C7D2F2;
  //  .other {
  //    text-align: center;
  //    margin-top: 205px;
  //    font-weight: bold;
  //    font-size: 14px;
  //  }
  //}
  &-firstBox {
    width: 200px;
    height: 40px;
    text-align: center;
    outline: 0.1px solid #c7d2f2;
  }
  //&-info {
  //  margin-top: 10px;
  //  font-weight: bold;
  //}
  &-doublebox-info {
    margin-top: 25px;
  }
  &-info {
    margin-top: 10px;
  }
  //&-firstBox {
  //  width: 200px;
  //  height: 210px;
  //  text-align: left;
  //  outline: 0.1px solid #C7D2F2;
  //}
  //&-info {
  //  margin-top: 15px;
  //  height: 188px;
  //  border-left: 5px solid #1F62C5;
  //  background-color: #DCE5FF;
  //  padding: 6px;
  //  .content1 {
  //    font-weight: bold;
  //    font-size: 14px;
  //  }
  //  .content2 {
  //    font-size: 12px;
  //  }
  //}
  &-column {
    width: 200px;
    height: 60px;
    color: #1f62c5;
    outline: 0.1px solid #c7d2f2;
  }
  &-column1 {
    width: 200px;
    height: 50px;
    color: #333333;
    outline: 0.1px solid #c7d2f2;
  }
}
@media screen and(max-width:999px) {
  #video {
    margin-top: 20px;
    height: 844px;
    & > video {
      width: 100%;
      height: 24%;
    }
    .video-content {
      width: 100vw;
      position: static;
      background: #373b3e;
      .content-title1 {
        padding-top: 130px;
        width: 80%;
      }
      .content-title2 {
        .t1,
        .t2 {
          width: 120px;
          height: 32px;
          line-height: 32px;
          font-size: 13px;
          padding: 0;
        }
      }
    }
    .content-title3 {
      .title3Text {
        color: #ffffff;
        padding: 3px;
      }
    }
    .content-title4 {
      & > button {
        width: 193px !important;
        height: 33px !important;
        & > a {
          font-size: 14px !important;
          & > img {
            width: 7px;
          }
        }
      }
    }
    .video-content2 {
      width: 100%;
      left: 0;
      bottom: 156px;
      height: auto;
      & > p {
        font-size: 14px !important;
      }
    }
  }
  .service {
    padding: 0px 0 55px;
  }
  .service-1-container {
    flex-direction: column;
    & > img {
      margin-left: 0;
    }
  }

  .title-contact {
    width: auto;
    height: auto;
    font-size: 45px;
  }
  .cus-table {
    width: 100%;
    .cus-table-cell {
      height: auto;
      min-height: 55px;
      line-height: 1.5;
    }
    .cus-table-key {
      width: 120px;
    }
    .cus-table-val {
      width: 300px;
    }
  }
  .colContent {
    margin: 10px auto !important;
  }
  .rowContent {
    font-size: 16px !important;
  }
}
.zp-table {
  width: 100%;
  &-title {
    width: 100%;
    background: #e7edff;
    display: flex;
    justify-content: center;
    font-weight: bold;
    font-size: 20px;
  }
  &-cell {
    width: 100%;
    background: #fbf7e6;
    display: flex;
    justify-content: center;
    outline: 0.1px solid #c7d2f2;
  }
  &-content {
    width: 100%;
    display: flex;
    justify-content: center;
    outline: 0.1px solid #c7d2f2;
  }
  &-column {
    font-size: 14px;
    height: 40px;
    color: #1f62c5;
    outline: 0.1px solid #c7d2f2;
  }
  &-column1 {
    font-size: 14px;
    height: 40px;
    color: #333333;
    outline: 0.1px solid #c7d2f2;
  }
  &-box {
    width: 100%;
    height: 40px;
    text-align: left;
    outline: 0.1px solid #c7d2f2;
  }
  &-info {
    margin-top: 10px;
  }
}
</style>
